import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { NewRequisitionType } from "./types";
import NewReqBillingInformation from "./NewReqBillingInformation";
import { ViewOnlyOrderDetailsContent } from "./NewRequisition.styles";
import ClinicalIndication from "./NewReqClinicalIndication";
import PatientInformation from "./NewReqPatientInformation";
import { convertNewReqTypeToForm } from "./Services/helpers";
import ClinicInformation from "./NewReqClinicInformation";
import {
  OrderDetailsDialogTitle,
  OrderDetailsMetadata,
} from "./OrderDetailsDialog";

interface NewReqOrderDialogProps {
  open: boolean;
  onClose: () => void;
  orderData: NewRequisitionType;
}

export const NewReqOrderDialog: React.FC<NewReqOrderDialogProps> = ({
  open,
  onClose,
  orderData,
}) => {
  const convertedFormData = convertNewReqTypeToForm(orderData);

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <OrderDetailsDialogTitle id="customized-dialog-title" onClose={onClose} />
      <DialogContent>
        <ViewOnlyOrderDetailsContent>
          <OrderDetailsMetadata
            orderNumber={orderData.unity_complete_id}
            created={orderData}
          />
          <ClinicInformation
            preflight
            submittedRequisition={convertedFormData}
          />
          <PatientInformation
            preflight
            submittedRequisition={convertedFormData}
          />
          <ClinicalIndication
            preflight
            submittedRequisition={convertedFormData}
          />
          <NewReqBillingInformation
            preflight
            submittedRequisition={convertedFormData}
          />
        </ViewOnlyOrderDetailsContent>
      </DialogContent>
    </Dialog>
  );
};
